/* import __COLOCATED_TEMPLATE__ from './selection-area.hbs'; */
/* eslint-disable ember/classic-decorator-no-classic-methods */
import Component from '@ember/component';
import { action } from '@ember/object';

////////////////////////////////////////////////////////////////////////////////////
// selection-area - Component that manages part selection                         //
////////////////////////////////////////////////////////////////////////////////////

export default class SelectionArea extends Component {
  tagName = '';
  isSelectorOpened = false;

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action toggleDropdown() {
    this.set('isSelectorOpened', !this.isSelectorOpened);
  }
}
